import classNames from 'classnames';

import { Button, Text } from '@pentabd/ui';

import { capitalizeFirstLetter } from '@utils/capitalize';

interface OrderDateType {
  orderDateData: object[];
  activeState: number | null;
  action: (arg: number) => void;
  query: any;
}

export const OrderDate = ({
  orderDateData,
  activeState,
  action,
}: OrderDateType) => {
  return (
    <div className="btn-group">
      {orderDateData.map((item: any, i: number) => {
        return (
          <Button
            key={i}
            fill="transparent"
            size="sm"
            type="light"
            className={classNames('py-5', {
              'text-primary-darker border-b-primary-darker border-bottom  rounded-0':
                activeState === i,
            })}
            onClick={() => action(i)}
          >
            <Text>{capitalizeFirstLetter(item.label)}</Text>
          </Button>
        );
      })}
    </div>
  );
};
